module.exports = __webpack_public_path__ + "img/minus.f8b82462.svg";